import M_ENV from '../../main/components/env/index.js'
import M_BRIDGE from './../components/bridge/index.js'
import M_EVENT_LISTENER from './components/event_listener/index.js'
import { M_PUBLIC_PARAMS, M_CONTENT_PARAMS, M_LOCATION_PARAMS } from './components/common_params/index.js'
import M_COLLECT_DATA from './components/collect_data/index.js'

/**
 * @description: 数据采集类
 */
class Collect {

    constructor () {
        // public公参
        this.public_params = {}
        // 业务公参
        this.business_params = {}
        // 内容公参
        this.content_params = {}
        // 位置参数
        this.location_params = {}
    }

    /**
     * @description: 外部执行方法
     * @param {String} cmd 指令
     * @param {Object} main 外部实例
     * @param {Object} params 传入参数
     * @return {Object}
     */
    execute (cmd, main, params) {
        // 总开关
        if (!main.mainSwitch) {
            return
        }
        // 公参
        const com_params = {
            public_params: this.public_params,
            content_params: this.content_params,
            business_params: this.business_params,
            location_params: this.location_params
        }
        switch (cmd) {
            case 'init': // 初始化
                this._init(main)
                break
            case 'base': // 基础数据采集
                return M_COLLECT_DATA.collectBase(main, params, com_params)
            case 'pv': // pv数据采集
                return M_COLLECT_DATA.collectPV(main, params)
            case 'leave': // leave数据采集
                return M_COLLECT_DATA.collectLeave(main, params)
            case 'pageStay': // 页面停留数据采集
                return M_COLLECT_DATA.collectStay(main, params)
            case 'dom': // dom节点数据采集
                return M_COLLECT_DATA.collectDom(main, params)
            case 'updateBusiness': // 更新业务公参命令
                this._updateBusiness(params)
                break

            default:
                break
        }
    }

    /**
     * @description: 初始化
     * @param {Object} main 外部实例
     */
    _init (main) {
        // 公参获取
        this._getCommonParams(main)
        // 事件绑定
        this._addCollectEventListener(main)
    }
    /**
     * @description: 获取公参
     * @param {Object} main 外部实例
     */
    async _getCommonParams (main) {
        // public公参
        this.public_params = M_PUBLIC_PARAMS()
        // 内容公参
        this.content_params = M_CONTENT_PARAMS(main)
        // 位置参数
        this.location_params = await M_LOCATION_PARAMS(main)
    }

    /**
     * @description: 事件绑定
     * @param {Object} main 外部实例
     */
    _addCollectEventListener (main) {
        M_EVENT_LISTENER(main)
    }

    /**
     * @description: 更新业务公参
     * @param {Object} params 更新参数
     */
    _updateBusiness (params) {
        if (M_ENV.isInApp) {
            // 由APP更新 business_params 的值，并负责维护，APP会在上报的信息体中增加business_params参数
            M_BRIDGE.invoke('updateBusinessParam', {
                params: { 
                    business_params: params.business_params,
                    url: params.url || ''
                },
                callback: (res) => {
                    params.callback && params.callback(res)
                }
            })
        } else {
            this.business_params = Object.assign({}, params.business_params)
        }
    }

}

export default new Collect()